import { createAction } from '@reduxjs/toolkit';

/**
 * Represents an enumeration of supported actions.
 */
export enum Actions {
	UPDATE_EPIC = '[JSW INTERACTIVE ROADMAP] UPDATE_EPIC',
	ADD_STORY = '[JSW INTERACTIVE ROADMAP] ADD_STORY',
	SET_EDIT_MODE_ITEM = '[JSW INTERACTIVE ROADMAP] SET_EDIT_MODE_ITEM',
	UPDATE_STORY = '[JSW INTERACTIVE ROADMAP] UPDATE_STORY',
	SET_PROJECT_TIMELINE = '[JSW INTERACTIVE ROADMAP] SET_PROJECT_TIMELINE',
	ADJUST_PROJECT_TIMELINE = '[JSW INTERACTIVE ROADMAP] ADJUST_PROJECT_TIMELINE',
	MAP_PROJECT_DEPENDENCIES = '[JSW INTERACTIVE ROADMAP] MAP_PROJECT_DEPENDENCIES',
	RESET_DEMO = '[JSW INTERACTIVE ROADMAP] RESET_DEMO',
	COMPLETE_DEMO = '[JSW INTERACTIVE ROADMAP] COMPLETE_DEMO',
	UNLINK_DEPENDENCY = '[JSW INTERACTIVE ROADMAP] UNLINK_DEPENDENCY',
}

/**
 * Represents an action payload to create an epic.
 */
export type UpdateEpicActionPayload = {
	readonly epicName: string;
	readonly epicIndex: number;
};

/**
 * Represents an action payload to create an epic.
 */
export type UpdateStoryActionPayload = {
	readonly storyName: string;
	readonly storyIndex: number;
	readonly epicIndex: number;
};

/**
 * Represents an action payload to create a project timeline.
 */
export type SetProjectTimelineActionPayload = {
	readonly storyIndex: number;
};

/**
 * Represents an action payload to update a project timeline.
 */
export type AdjustProjectTimelineActionPayload = {
	readonly storyIndex: number;
};

/**
 * Represents an action payload to set the edit mode item.
 */
export type SetEditModeItemActionPayload = {
	readonly id: string | undefined;
};

/**
 * Represents an action to create an epic.
 */
export const updateEpic = createAction<UpdateEpicActionPayload>(Actions.UPDATE_EPIC);

/**
 * Represents an action to add story.
 */
export const addStory = createAction(Actions.ADD_STORY);

/**ß
 * Represents an action to update a story.
 */
export const updateStory = createAction<UpdateStoryActionPayload>(Actions.UPDATE_STORY);

/**
 * Represents an action to set the project timeline.
 */
export const setProjectTimeline = createAction<SetProjectTimelineActionPayload>(
	Actions.SET_PROJECT_TIMELINE,
);

/**
 * Represents an action to adjust the project timeline.
 */
export const adjustProjectTimeline = createAction<AdjustProjectTimelineActionPayload>(
	Actions.ADJUST_PROJECT_TIMELINE,
);

/**
 * Represents an action to map the project dependency.
 */
export const mapProjectDependicies = createAction(Actions.MAP_PROJECT_DEPENDENCIES);

/**
 * Represents an action to complete the demo.
 */
export const completeDemo = createAction(Actions.COMPLETE_DEMO);

/**
 * Represents an action to reset demo.
 */
export const resetDemo = createAction(Actions.RESET_DEMO);

/**
 * Represents an action to unlink dependency.
 */
export const unlinkDependency = createAction(Actions.UNLINK_DEPENDENCY);

/**
 * Represents an action to set the edit mode item.
 */
export const setEditModeItem = createAction<SetEditModeItemActionPayload>(
	Actions.SET_EDIT_MODE_ITEM,
);
